<div [innerHTML]="text | safe:'html'"></div>